import React, { useState } from "react";
import { Col, Row, Container, Button, Card } from "react-bootstrap";
import WantedItem from "../WantedItem/WantedItem";
import classes from "./Wanted.module.scss";
import { useRouter } from "next/router";
import { useQuery } from "@tanstack/react-query";
import { fetchJobOffers } from "../../../data/jobOffers/jobOffers";
import { ReactBootstrapHTMLContainerProps } from "../../../types/htmlElementTypes";
import { useTranslation } from "next-i18next";

interface Props extends ReactBootstrapHTMLContainerProps { }

const Wanted = ({ className, ...htmlProps }: Props) => {
  const { t } = useTranslation("career");
  const [offersExpanded, setOffersExpanded] = useState(false);
  const { locale } = useRouter();
  const { data } = useQuery(
    [
      "job-offers",
      {
        locale: locale!,
      },
    ],
    fetchJobOffers,
    {
      enabled: !!locale,
    }
  );

  if (!data?.data?.length) {
    return null;
  }

  const defaultDisplayCount: number = 4;
  const offersCount: number = data.data.length;
  const offersToDisplay: number = offersExpanded
    ? offersCount
    : defaultDisplayCount;

  const offerExpandHandler = () => {
    setOffersExpanded((prev) => !prev);
  };

  return (
    <Container {...htmlProps} className={classes.wanted}>
      <h1 className={classes.wanted__title}>{t("job_offers.title")}</h1>
      <Row>
        {data.data.slice(0, offersToDisplay).map((job) => (
          <WantedItem
            key={job.id}
            position={job.attributes.title}
            requirements={job.attributes.requirements}
            advantages={job.attributes.advantages}
          />
        ))}

        {offersCount > defaultDisplayCount && (
          <div>
            <Button
              variant="secondary"
              className="mt-4 mt-lg-8 mb-4"
              onClick={offerExpandHandler}
            >
              {!offersExpanded
                ? t("job_offers.expand_button")
                : t("job_offers.collapse_button")}
            </Button>
          </div>
        )}
      </Row>
      {offersCount === 0 && (
        <div className="d-flex justify-content-center">
          <div className={classes.wanted__noPositions}>
            <p className="px-4 px-lg-10 text-center fs-4">
              {t("job_offers.not_hiring")}
            </p>
          </div>
        </div>
      )}
    </Container>
  );
};

export default Wanted;
